import _find from 'lodash/find'
import _each from 'lodash/each'
import { createI18n } from 'vue-i18n'
import messages from './front/trans.en.js'

const i18n = createI18n({ legacy: true, locale: 'en', messages: messages })

export const _validateElement = function (el) {
    // The element can be detached from the DOM during dynamic form updates or
    // component teardown. Walking the parentElement chain below would then throw
    // ("null is not an object"), so skip validation safely and treat it as valid.
    if (!el || !el.isConnected) {
        return true
    }
    const field = el.closest('.app--field')
    if (el.nodeName == 'INPUT' || el.nodeName == 'SELECT' || el.nodeName == 'TEXTAREA') {
        el.setCustomValidity('')
        el.classList.remove('is-invalid', 'is-valid')
        if (field) {
            field.classList.remove('is-invalid')
        }
        el.checkValidity()
        el.dispatchEvent(new Event('validation:custom'))
        let attribute = el.getAttribute('data-label')
            ? el.getAttribute('data-label')
            : el.closest('.datepicker') && el.closest('.datepicker').getAttribute('data-label')
              ? el.closest('.datepicker').getAttribute('data-label')
              : ''
        if (!attribute) {
            attribute = el.getAttribute('placeholder') ? el.getAttribute('placeholder') : ''
        }
        let nodes = el.parentElement?.querySelectorAll('.invalid-feedback') || []
        nodes =
            nodes.length == 0
                ? el.parentElement?.parentElement?.querySelectorAll('.invalid-feedback') || []
                : nodes
        nodes =
            nodes.length == 0
                ? el.parentElement?.parentElement?.parentElement?.querySelectorAll('.invalid-feedback') || []
                : nodes
        nodes =
            nodes.length == 0
                ? el.parentElement?.closest('.date-picker-element-wrapper')?.querySelectorAll('.invalid-feedback') || []
                : nodes

        let container = nodes.length > 1 ? _find(nodes, c => c.getAttribute('for') == attribute) : nodes[0]
        container = container ? container : nodes[0]

        if (el.validity.valueMissing === true) {
            el.setCustomValidity(
                i18n.global.t('validation.required', {
                    attribute: attribute.charAt(0).toUpperCase() + attribute.slice(1).toLowerCase()
                })
            )
        } else if (
            el.validity.tooShort === true ||
            (el.getAttribute('minlength') && el.value.length > 0 && el.value.length < el.getAttribute('minlength'))
        ) {
            el.setCustomValidity(
                i18n.global.t('validation.min.string', {
                    attribute: attribute.toLowerCase(),
                    min: el.getAttribute('minlength')
                })
            )
        } else if (
            el.validity.tooLong === true ||
            (el.getAttribute('maxlength') && el.value.length > 0 && el.value.length > el.getAttribute('maxlength'))
        ) {
            el.setCustomValidity(
                i18n.global.t('validation.max.string', {
                    attribute: attribute.toLowerCase(),
                    max: el.getAttribute('maxlength')
                })
            )
        } else if (el.validity.rangeUnderflow === true) {
            el.setCustomValidity(
                i18n.global.t('validation.min.numeric', {
                    attribute: attribute.toLowerCase(),
                    min: el.getAttribute('min')
                })
            )
        } else if (el.validity.rangeOverflow === true) {
            el.setCustomValidity(
                i18n.global.t('validation.max.numeric', {
                    attribute: attribute.toLowerCase(),
                    max: el.getAttribute('max')
                })
            )
        } else if (el.validity.typeMismatch === true || el.validity.patternMismatch) {
            el.setCustomValidity(i18n.global.t('validation.regex', { attribute: attribute.toLowerCase() }))
        }

        if (typeof container != 'undefined') {
            if (el.validity.valid) {
                container.innerHTML = ''
                container.classList.remove('d-inline-block')
                el.classList.add('is-valid')
                el.dispatchEvent(new Event('valid'))
            } else {
                container.innerHTML = el.validationMessage
                container.classList.add('d-inline-block')
                el.classList.add('is-invalid')
                if (field) {
                    field.classList.add('is-invalid')
                }
                el.dispatchEvent(new Event('invalid'))
            }
        }

        return el.validity.valid
    }

    console.warn('Element validation skipped: ' + el.nodeName)
    console.warn(el)
    return true
}

const _validate = function (event, throwErrorOnFail = false) {
    return new Promise(function (resolve, reject) {
        let form = event.target
        if (form.nodeName !== 'FORM') {
            if (throwErrorOnFail === true) {
                reject(false)
            }

            return
        }

        let valid = true
        _each(form.elements, el => {
            if (
                (el.nodeName == 'INPUT' || el.nodeName == 'SELECT' || el.nodeName == 'TEXTAREA') &&
                !el.classList.contains('multiselect__input')
            ) {
                if (_validateElement(el) == false) {
                    valid = false
                }
            }
        })

        if (valid == false) {
            if (typeof event.preventDefault === 'function') {
                event.preventDefault()
            }

            if (typeof event.stopPropagation === 'function') {
                event.stopPropagation()
            }

            form.classList.add('was-validated')
            if (throwErrorOnFail === true) {
                reject(false)
            }
            return
        }

        resolve(true)
    })
}

const _reset = function (form) {
    form.classList.remove('was-validated')
    _each(form.elements, el => {
        if (el.nodeName == 'INPUT' || el.nodeName == 'SELECT' || el.nodeName == 'TEXTAREA') {
            el.classList.remove('is-valid', 'is-invalid')
            if (el.closest('.app--field')) {
                el.closest('.app--field').classList.remove('is-invalid')
            }
            el.setCustomValidity('')
            el.dispatchEvent(new Event('validation:reset'))
        }
    })
    return true
}

export default {
    install: (app, options) => {
        // Returns element if element is invalid, null if all elements are valid
        app.config.globalProperties.$validatePage = function (page) {
            let invalid = null
            let groups = page.querySelectorAll('.app--engagement-group.visible')
            _each(groups, group => {
                let elements = group.querySelectorAll('.app--engagement-element.visible')
                _each(elements, element => {
                    let inputs = element.querySelectorAll(
                        'input:not(.no-validate), select:not(.no-validate), textarea:not(.no-validate)'
                    )
                    _each(inputs, input => {
                        if (_validateElement(input) == false && invalid === null) {
                            invalid = element
                        }
                    })
                    let calculated = element.querySelector('.calculated.calculated-invalid')
                    if (calculated) {
                        calculated.dispatchEvent(new Event('validation:calculated'))
                        if (invalid === null) {
                            invalid = element
                        }
                    }
                })
            })
            return invalid
        }

        app.config.globalProperties.$validate = function (event, throwErrorOnFail) {
            let element = event.target
            if (!element) {
                return
            }
            if (element.nodeName == 'INPUT' || element.nodeName == 'SELECT' || element.nodeName == 'TEXTAREA') {
                return _validateElement(element)
            }
            if (element.nodeName == 'FORM') {
                return _validate(event, throwErrorOnFail)
            }
            throw new Error(
                'Invalid parameter! event.target must be a form, input, select, or textarea (' +
                    element.nodeName +
                    ' given).'
            )
        }

        app.config.globalProperties.$validationReset = function (form) {
            if (!form) {
                return
            }
            if (form && form.nodeName == 'FORM') {
                return _reset(form)
            }
            throw new Error('Invalid paramater! Parameter must be a form (' + form.nodeName + ' given).')
        }

        app.directive('validate', {
            beforeMount(element, binding) {
                if (element.nodeName == 'INPUT' || element.nodeName == 'SELECT' || element.nodeName == 'TEXTAREA') {
                    element.addEventListener(
                        'validation:custom',
                        function (event) {
                            binding.value(event)
                        },
                        false
                    )
                }
            }
        })
    }
}
